import { createContext } from "react";

export const wishListLength = createContext();
export const cartLength = createContext();